import { z } from 'zod';

import {
  CollectionKind,
  CollectionRole,
  CollectionSortOrder,
  CollectionStatus,
} from '@nucleus-commerce/api-client/admin';

import { rulesFormSchema } from '@/features/product-rules';
import { seoOverrideSchema } from '@/features/seo';

const HANDLE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

/** Manual collections keep an empty rule set the mapper drops; automated ones need at least one condition. */
export const collectionFormSchema = z
  .object({
    kind: z.enum(CollectionKind),
    title: z
      .string()
      .trim()
      .min(1, { error: 'collections:validation.titleRequired' })
      .max(200, { error: 'collections:validation.titleLength' }),
    handle: z
      .string()
      .trim()
      .min(1, { error: 'collections:validation.handleRequired' })
      .max(120)
      .regex(HANDLE, { error: 'collections:validation.handleFormat' }),
    descriptionHtml: z.string().trim(),
    mediaId: z.string().nullable(),
    seo: seoOverrideSchema,
    sortOrder: z.enum(CollectionSortOrder),
    status: z.enum(CollectionStatus),
    role: z.enum(CollectionRole),
    eyebrow: z.string().trim().max(120, { error: 'collections:validation.eyebrowLength' }),
    productTypeId: z.string().nullable(),
    rules: rulesFormSchema,
  })
  .refine((v) => v.kind !== 'automated' || v.rules.conditions.length > 0, {
    path: ['rules', 'conditions'],
    error: 'collections:validation.conditionsRequired',
  });

export type CollectionFormInput = z.input<typeof collectionFormSchema>;
export type CollectionFormOutput = z.output<typeof collectionFormSchema>;
